import React from "react";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import Photoalbum from "./Photoalbum.jsx";

const PhotoalbumJSON = ({ dir, lang }) => {
  const [photos, loadingPhotos] = useFetch("https://sancta-cecilia.cz/photo_json.php?dir=" + dir);

  return loadingPhotos ? loading[lang] : <Photoalbum photos={photos} />;
};

export default PhotoalbumJSON;



// WEBPACK FOOTER //
// ./src/components/Photogallery/PhotoalbumJSON.jsx